export default __webpack_public_path__ + "static/report-filtered-fe1831a69830372382f8e93e872d2e2d.mp4";